"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Twitter = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var Twitter = function Twitter() {
  return react_1.default.createElement("path", {
    fill: "currentColor",
    d: "M23.965 4.957a9.588 9.588 0 01-2.217 2.133v.66a14.628 14.628 0 01-4.345 10.43 14.614 14.614 0 01-10.476 4.219 14.66 14.66 0 01-6.53-1.51.3.3 0 01-.18-.277v-.131c0-.173.14-.312.311-.312a10.613 10.613 0 006.135-2.206 5.236 5.236 0 01-4.661-3.069.312.312 0 01.311-.431 4.79 4.79 0 001.822-.168A5.226 5.226 0 010 9.728a.312.312 0 01.431-.312 4.79 4.79 0 001.893.408A5.132 5.132 0 01.277 3.902a.647.647 0 011.09-.216 14.807 14.807 0 0010.077 4.651 4.796 4.796 0 01-.144-1.199 5.222 5.222 0 018.998-3.524c.998-.19 1.963-.525 2.864-.995a.204.204 0 01.216 0 .204.204 0 010 .216 5.238 5.238 0 01-2.109 2.397 10.279 10.279 0 002.396-.575.191.191 0 01.216 0 .204.204 0 01.084.3z"
  });
};

exports.Twitter = Twitter;